import {
  Clipboard, Thermometer, Droplets, Flame, ShieldCheck, Wifi,
  AlertTriangle, Wind, Snowflake, Sun, Cloud, CloudRain, Zap,
  Camera, Bell, Battery, Bath, Lock, KeyRound, Home, Building2,
  Trees, Leaf, TreePine, Sprout, Flower2, Waves, Fish, Bug,
  Wrench, Hammer, Trash2, Package, Mail, Newspaper, Package2,
  Cpu, HardDrive, Router, Signal, Radio, Tv, Speaker, Lightbulb,
  Circle, Gauge, Fuel, Utensils, Refrigerator, Microwave,
  DoorOpen, DoorClosed, Warehouse, Car, ParkingCircle, Bike,
  Umbrella, Sofa, BedDouble, ChefHat, ShowerHead,
} from "lucide-react";

/**
 * Icon-Map für die systemweite Live-Status-Schema-Konfiguration
 * (Feb 2026 · Struktur-Fix).
 *
 * Wenn Admin einen Punkt anlegt, wählt er einen Icon-Namen aus dem
 * `ICON_CHOICES`-Array — dieser wird über `ICON_MAP` zur Runtime auf
 * das Lucide-Component gemappt. Fallback: `Circle`.
 */
export const ICON_MAP = {
  Clipboard, Thermometer, Droplets, Flame, ShieldCheck, Wifi,
  AlertTriangle, Wind, Snowflake, Sun, Cloud, CloudRain, Zap,
  Camera, Bell, Battery, Bath, Lock, KeyRound, Home, Building2,
  Trees, Leaf, TreePine, Sprout, Flower2, Waves, Fish, Bug,
  Wrench, Hammer, Trash2, Package, Mail, Newspaper, Package2,
  Cpu, HardDrive, Router, Signal, Radio, Tv, Speaker, Lightbulb,
  Circle, Gauge, Fuel, Utensils, Refrigerator, Microwave,
  DoorOpen, DoorClosed, Warehouse, Car, ParkingCircle, Bike,
  Umbrella, Sofa, BedDouble, ChefHat, ShowerHead,
};

/** Auswählbare Icons im Schema-Editor. Kuratierte Liste — reicht für
 *  alle typischen Objektbetreuungs-Kategorien. */
export const ICON_CHOICES = [
  { value: "Clipboard", label: "Klemmbrett" },
  { value: "Thermometer", label: "Thermometer" },
  { value: "Droplets", label: "Wassertropfen" },
  { value: "Flame", label: "Flamme" },
  { value: "ShieldCheck", label: "Schild" },
  { value: "Wifi", label: "WLAN" },
  { value: "AlertTriangle", label: "Warnung" },
  { value: "Wind", label: "Wind / Lüftung" },
  { value: "Snowflake", label: "Kälte" },
  { value: "Sun", label: "Sonne" },
  { value: "Cloud", label: "Wolke" },
  { value: "CloudRain", label: "Regen" },
  { value: "Zap", label: "Strom" },
  { value: "Camera", label: "Kamera" },
  { value: "Bell", label: "Glocke" },
  { value: "Battery", label: "Batterie" },
  { value: "Bath", label: "Bad" },
  { value: "Lock", label: "Schloss" },
  { value: "KeyRound", label: "Schlüssel" },
  { value: "Home", label: "Haus" },
  { value: "Building2", label: "Gebäude" },
  { value: "Trees", label: "Bäume" },
  { value: "Leaf", label: "Blatt" },
  { value: "TreePine", label: "Nadelbaum" },
  { value: "Sprout", label: "Setzling" },
  { value: "Flower2", label: "Blume" },
  { value: "Waves", label: "Wellen" },
  { value: "Fish", label: "Fisch / Aquarium" },
  { value: "Bug", label: "Schädling" },
  { value: "Wrench", label: "Werkzeug" },
  { value: "Hammer", label: "Hammer" },
  { value: "Trash2", label: "Mülleimer" },
  { value: "Package", label: "Paket" },
  { value: "Mail", label: "Post" },
  { value: "Newspaper", label: "Zeitung" },
  { value: "Package2", label: "Lieferung" },
  { value: "Cpu", label: "Prozessor" },
  { value: "HardDrive", label: "Speicher" },
  { value: "Router", label: "Router" },
  { value: "Signal", label: "Signal" },
  { value: "Radio", label: "Radio" },
  { value: "Tv", label: "TV" },
  { value: "Speaker", label: "Lautsprecher" },
  { value: "Lightbulb", label: "Glühbirne" },
  { value: "Circle", label: "Punkt (neutral)" },
  { value: "Gauge", label: "Anzeige" },
  { value: "Fuel", label: "Kraftstoff / Öltank" },
  { value: "Utensils", label: "Küche" },
  { value: "Refrigerator", label: "Kühlschrank" },
  { value: "Microwave", label: "Mikrowelle" },
  { value: "DoorOpen", label: "Tür offen" },
  { value: "DoorClosed", label: "Tür geschlossen" },
  { value: "Warehouse", label: "Lager" },
  { value: "Car", label: "Auto" },
  { value: "ParkingCircle", label: "Parkplatz" },
  { value: "Bike", label: "Fahrrad" },
  { value: "Umbrella", label: "Schirm / Wetter" },
  { value: "Sofa", label: "Wohnzimmer" },
  { value: "BedDouble", label: "Schlafzimmer" },
  { value: "ChefHat", label: "Küchenchef" },
  { value: "ShowerHead", label: "Dusche" },
];

/** Resolver — verwendet in `CustomerStatusPreview` + Schema-Editor. */
export function resolveIcon(name) {
  return ICON_MAP[name] || Circle;
}
